// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d17e9e7e","455":"65cae4a3","977":"1fcc698c"}[chunkId] + ".chunk.js";
};